/* eslint-disable react-refresh/only-export-components */
import { DimeCheckbox, DimeSeparator } from '@nudool/design-system';
import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';

export const Route = createFileRoute('/design-system/checkbox')({
  component: CheckboxDocs,
});

function DocsSection({ title, children }: Readonly<{ title: string; children: React.ReactNode }>) {
  return (
    <section className="mb-10">
      <h2 className="mb-1 text-xl font-semibold">{title}</h2>
      <DimeSeparator className="mb-4" />
      {children}
    </section>
  );
}

function Preview({ children }: Readonly<{ children: React.ReactNode }>) {
  return (
    <div className="flex flex-wrap items-center gap-6 rounded-lg border border-border bg-background p-6">
      {children}
    </div>
  );
}

function CheckboxDocs() {
  const [checked, setChecked] = React.useState(false);

  return (
    <div>
      <h1 className="mb-1 text-3xl font-bold">Checkbox</h1>
      <p className="mb-8 text-muted-foreground">
        Binary toggle for boolean options. Supports checked, unchecked, and indeterminate states.
      </p>

      <DocsSection title="States">
        <Preview>
          <label className="flex items-center gap-2 text-sm">
            <DimeCheckbox />
            Unchecked
          </label>
          <label className="flex items-center gap-2 text-sm">
            <DimeCheckbox defaultChecked />
            Checked
          </label>
          <label className="flex items-center gap-2 text-sm">
            <DimeCheckbox checked="indeterminate" />
            Indeterminate
          </label>
        </Preview>
      </DocsSection>

      <DocsSection title="Disabled">
        <Preview>
          <label className="flex items-center gap-2 text-sm text-muted-foreground">
            <DimeCheckbox disabled />
            Disabled unchecked
          </label>
          <label className="flex items-center gap-2 text-sm text-muted-foreground">
            <DimeCheckbox disabled defaultChecked />
            Disabled checked
          </label>
        </Preview>
      </DocsSection>

      <DocsSection title="Controlled">
        <Preview>
          <label className="flex items-center gap-2 text-sm">
            <DimeCheckbox
              checked={checked}
              onCheckedChange={(val: boolean | 'indeterminate') => setChecked(val === true)}
            />
            {checked ? 'Enabled' : 'Disabled'}
          </label>
        </Preview>
      </DocsSection>
    </div>
  );
}
